import {SOPutCustomLogicRequirement} from '../../core/custom-logic-requirement/so-put-custom-logic-requirement';
import {CustomLogicRequirementCore} from './custom-logic-requirement.core';
import {SOGetCustomLogicRequirement} from '../../core/custom-logic-requirement/so-get-custom-logic-requirement';
import {FormField, SelectionOption} from 'lionheartland';
import {putCustomLogicRequirementFormFieldOptions} from './put-custom-logic-requirement-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutCustomLogicRequirement extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putCustomLogicRequirementFormFieldOptions);

  RequestClass = SOPutCustomLogicRequirement

  constructor(
    public entityCore: CustomLogicRequirementCore
  ) {
    super();
    if (putCustomLogicRequirementFormFieldOptions.parent) {
      putCustomLogicRequirementFormFieldOptions.parent.makeCore = true;
    }
    if (putCustomLogicRequirementFormFieldOptions.project) {
      putCustomLogicRequirementFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('active'),
      this.getFormValueFromIdentifier('currentStatus'),
      this.getFormValueFromIdentifier(
        'parent',
        SOGetCustomLogicRequirement,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}